module.exports = __webpack_public_path__ + "static/img/star5.0b09db95.png";